export const RTT_BUCKETS = [50, 100, 150, 200, 300, 500, 1000, 3000, Infinity];
export function percentile(values, q) {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  return sorted[Math.ceil(sorted.length * q) - 1];
}

// Remote reports can repeat between polls. Never count the same report twice.
export function readAudio(report, previous) {
  const result = { in_received: 0, in_lost: 0, out_lost: 0, out_sent: 0,
    concealed: 0, audio_samples: 0, in_coverage_ms: 0, out_coverage_ms: 0, concealment_coverage_ms: 0,
    in_jitter: [], out_jitter: [], media_rtt: [] };
  const delta = (row, old, name) => {
    if (!old || !Number.isFinite(row[name]) || !Number.isFinite(old[name]) || row[name] < 0 || old[name] < 0) return null;
    const difference = row[name] - old[name];
    return difference >= 0 ? difference : null;
  };
  report.forEach(row => {
    if (!['inbound-rtp', 'outbound-rtp', 'remote-inbound-rtp'].includes(row.type)
      || (row.kind || row.mediaType) !== 'audio') return;
    const old = previous.get(row.id);
    if (old && row.timestamp <= old.timestamp) return;
    previous.set(row.id, row);
    const elapsed = old ? row.timestamp - old.timestamp : 0;
    // Suspension or a long reporting gap is unknown, not continuous coverage.
    const coverage = elapsed > 0 && elapsed <= 15000 ? elapsed : 0;
    if (row.type === 'inbound-rtp') {
      if (Number.isFinite(row.jitter)) result.in_jitter.push(row.jitter * 1000);
      const received = delta(row, old, 'packetsReceived');
      const lost = delta(row, old, 'packetsLost');
      if (coverage && received !== null && lost !== null) {
        result.in_received += received;
        result.in_lost += lost;
        result.in_coverage_ms += coverage;
      }
      const concealed = delta(row, old, 'concealedSamples');
      const samples = delta(row, old, 'totalSamplesReceived');
      if (coverage && concealed !== null && samples !== null) {
        result.concealed += concealed;
        result.audio_samples += samples;
        result.concealment_coverage_ms += coverage;
      }
    }
    if (row.type === 'remote-inbound-rtp') {
      if (Number.isFinite(row.jitter)) result.out_jitter.push(row.jitter * 1000);
      const measurements = delta(row, old, 'roundTripTimeMeasurements');
      if (Number.isFinite(row.roundTripTime) && (!old || measurements === null || measurements > 0)) result.media_rtt.push(row.roundTripTime * 1000);
      const local = report.get(row.localId);
      const sent = local && delta(local, old && old.localSnapshot, 'packetsSent');
      const lost = delta(row, old, 'packetsLost');
      if (coverage && sent !== null && sent !== undefined && lost !== null) {
        result.out_sent += sent;
        result.out_lost += lost;
        result.out_coverage_ms += coverage;
      }
      previous.set(row.id, { ...row, localSnapshot: local && { ...local } });
    }
  });
  return result;
}
